import { WriteDirectionEnum } from '@inter-ikea-kompis/enums/lib';
import { useServiceSettings } from 'contexts/serviceSettings';

const useWriteDirection = () => {
  return (useServiceSettings().dexfSettings.localisation.writeDirection ||
    WriteDirectionEnum.ltr) as 'ltr' | 'rtl';
};

export default useWriteDirection;
